import cartAdd from './includes/cart-add.js'
import cartModel from './includes/cart-model.js'
import CatalogItemClass from './includes/catalog-item.js'

class ItemPageClass {

  setInCart(incart) {
    this.$btnToCart.toggleClass('uk-button-danger',incart);
    this.$btnToCart.toggleClass('uk-button-secondary',!incart);
    this.$btnToCart.find('.out-cart').prop('hidden',incart);
    this.$btnToCart.find('.in-cart').prop('hidden',!incart);
  }
  
  cartRefresh() {
    let newItem = cartModel.itemById(this.item.NOM_ID);
    this.setInCart((newItem != null) && (newItem.COUNT_PACK > 0));
  }
  
  favRefresh() {
    $("#page-item-fav").toggleClass('in-fav',this.inFavorites);
    let favText = this.inFavorites?'Убрать товар из избранного':'Добавить товар в избранное'
    $("#page-item-fav").attr('uk-tooltip',"title: "+favText+"; pos: left;");                
  }

  initFavorites() {
    if (!registred) {
      $("#page-item-fav").hide()
      return
    }
    this.favRefresh()
    $("#page-item-fav").on('click',async (ev)=>{
      ev.preventDefault()
      this.inFavorites = !this.inFavorites;
      this.favRefresh();
      if (!this.inFavorites) {
        await $I.jsonAsync("/favorites/del/",{"nom_id" : this.item.NOM_ID});
        notify('Товар убран из избранного', 'success');
      } else {
        await $I.jsonAsync("/favorites/add/",{"nom_id" : this.item.NOM_ID});
        notify('Товар добавлен в избранное', 'success');
      }
    })
  }

  constructor(item) {
    this.$btnToCart = $("#page-item-add");
    this.item = item;
    this.item.PRICE = parseFloat(this.item.PRICE)
    
    this.$btnToCart.on('click',(ev)=>{
      ev.preventDefault()
      cartAdd.show(item);
    });
    
    cartModel.onChanged.push(()=>{
      this.cartRefresh();
    });
    this.cartRefresh();
    
    this.analogItems = [];
    $("#item-analogs").find('.shop-item').each((i,itm)=>{
      this.analogItems.push( new CatalogItemClass($(itm)) );
    });

    this.inFavorites = this.item.IN_FAVORITE === '1'
    this.initFavorites()
  }

}

let itemPage = null;
$(document).ready(()=>{
  itemPage = new ItemPageClass(item);
});